/*
 * @Author: wangbaihe
 * @Date: 2023-06-22 14:36:19
 * @LastEditors: liuxiuting
 * @LastEditTime: 2026-02-10 11:17:22
 * @FilePath: \carrier\packages\common-mediax\src\apis\MediaCloudPublishCenter\TVGroup.js
 * @Description: 串联单的接口
 */

import { createAPI } from '@common'

// MediaCloudPublishCenterTVGroup
export default {
  // 广电文稿
  // 获取子节点e5/admin/dom/folders
  getRootFunc: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60gpmefst0sppu', 'get', config),
  getRootFolderRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60gpmefst0sppu', 'get', config),
  // 不需要权限 全部
  getSubsAdminFunc: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60benjo0epn0gpmefst', 'get', config),
  // 返回权限列表
  getSubsFunc: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60gpmefst', 'get', config),

  getRootArticlesTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60gpmefst', 'get', config),
  // 存角色权限：文件夹权限
  postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config
    ),
  // 读角色权限：文件夹权限
  getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'get',
      config
    ),
  getE5AdminFlows: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60gmpxt', 'get', config),
  // 读文件夹
  getE5AdminFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60benjo0epn0gpmefs', 'get', config),
  postFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60benjo0epn0gpmefst', 'POST', config),
  deleteFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60benjo0epn0gpmefst', 'DELETE', config),
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  // 写稿/修改 初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0dsfbujpo0jojujbmj{bujpo',
      'get',
      config,
      {
        timeout: 30000
      }
    ),
  // 写稿/修改 初始化
  postSave: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0dsfbuf', 'POST', config, {
      timeout: 30000,
      isSimpleSecurity: true
    }),
  // 送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0qspd0usbotgfs', 'POST', config),
  // 审核通过
  postArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0qspd0qbtt', 'POST', config),
  // 稿件驳回
  postArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0qspd0sfkfdu', 'POST', config),
  // 删除稿件
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0qspd0efmfuf', 'POST', config),
  //  导出
  exportLayoutPlan: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0fyqpsu', 'post', config, {
      timeout: 12000000
    }),
  // 串联单导出时获取电视文稿人员信息
  exportGetUserLabels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0vtfsMbcfmt', 'GET', config),
  //  获取详情页
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0efubjm', 'GET', config),
  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0efubjm', 'GET', config),
  // 移动
  postRootArticlesMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0npwf', 'GET', config),
  // 复制稿件
  postRootArticlesCopy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0hspvq0dpqz', 'GET', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUser: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 获取不同用户修改痕迹(新)
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0wfstjpo0usbdf0vtfst0bmufsobuf0ofx',
      'get',
      config,
      vconfig
    ),
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0f60bdujpot0efubjmbdujpot', 'get', config),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 获取有权限文件夹的全部稿件列表
  getAllArticles: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfxy0uw0bsujdmft0hfuBmmBsujdmft', 'GET', config)
}
